import { render, staticRenderFns } from "./fwtk.vue?vue&type=template&id=0e3acef3&scoped=true"
import script from "./fwtk.vue?vue&type=script&lang=js"
export * from "./fwtk.vue?vue&type=script&lang=js"
import style0 from "./fwtk.vue?vue&type=style&index=0&id=0e3acef3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3acef3",
  null
  
)

export default component.exports